import { Check, MusicNote, Play } from 'iconoir-react';
import { cn } from '@listening/utils/react-helpers';

export function ChapterRowContent({
  status,
  name,
  meta,
}: {
  status: 'done' | 'now' | 'up';
  name: string;
  meta: string;
}) {
  return (
    <>
      <span
        className={cn(
          'grid size-5 shrink-0 place-items-center rounded-full',
          status === 'done' && 'bg-jade-250 text-jade-750',
          status === 'now' && 'bg-azure-595 text-white',
          status === 'up' && 'bg-steel-120 text-steel-700',
        )}
      >
        {status === 'done' && (
          <Check aria-hidden className='size-3' strokeWidth={3.5} />
        )}
        {status === 'now' && (
          <MusicNote aria-hidden className='size-3' strokeWidth={2.5} />
        )}
        {status === 'up' && (
          <Play aria-hidden className='size-3' fill='currentColor' />
        )}
      </span>
      <span className='flex min-w-0 flex-col'>
        <span className='truncate text-[12.5px] leading-tight font-semibold'>
          {name}
        </span>
        <span
          className={cn(
            'text-[11px] leading-tight font-semibold tabular-nums',
            status === 'done' && 'text-jade-750',
            status === 'now' && 'text-azure-455',
            status === 'up' && 'text-steel-700',
          )}
        >
          {meta}
        </span>
      </span>
    </>
  );
}
